<template>
    <div style="background:white" class="ve-list-page ve-list-page--embedded">
        <div class="suppo-dely-toolbar">
            <div class="toolbar-left-space"></div>
            <div class="toolbar-right-group">
                <el-button size="small" @click="dropSel('fldset')" icon="iconfont icon-ziyuan">
                    <span>{{ $LANG('0683', '字段设置') }}</span>
                </el-button>
            </div>
        </div>
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
            :table-data="tabData"
            :columnHiddenOption="columnHiddenOption"
            :footer-data="[]"
            :border-around="true"
            :border-x="true"
            :border-y="true"
            :fixed-header="true"
            row-key-field-name="IDSEQ"
            :row-style-option="rowStyleOption"
            :cell-style-option="cellStyleOption"
            :event-custom-option="eventCustomOption"
            :max-height="tabHeight"
            :virtual-scroll-option="virtualScrollOption"
            :scroll-width="0"
            :column-width-resize-option="columnWidthResizeOption"
            :cellSelectionOption="{enable: false}"
            :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            v-loading="loading"
            :element-loading-text="$LANG('2030', '数据加载中')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            id="po_send_main_table"
            ref="tabref">
        </ve-table>
        </div>
        <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px" class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input>
                <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <el-dialog v-if="setWin" :visible.sync="setWin" width="480px" append-to-body top="6vh"
            class="wb-field-settings-overlay" custom-class="wb-field-settings-dialog"
            :close-on-click-modal="false" :title="$LANG('0683', '字段设置')">
            <div slot="title" class="wb-field-settings-title">
                <i class="el-icon-setting" aria-hidden="true"></i>
                <div>
                    <h2>{{ $LANG('0683', '字段设置') }}</h2>
                    <p>{{ $LANG('', '拖拽调整顺序，勾选设置显示与冻结') }}</p>
                </div>
            </div>
            <easy-win class="wb-field-settings-editor" :colArr="fldArr" @child-exit="setWin=false" @child-sure="setOk" />
        </el-dialog>
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div>
            <div style="height:86vh;overflow-y:auto">
                <span v-for="(gpitem,gpind) in formArr" :key="gpind"  >
                    <div class="one-div">
                        <span class="oneRow"> {{gpitem.gpnm}} </span>
                    </div>
                    <Form :model="mainRow" :label-width="120" ref="supForm"  label-position="right" inline  >
                        <span v-for="(item,index) in gpitem.gplist" :key="index" >
                            <FormItem   :class=" 'item-width'" :prop="item.FLDNO"  v-if="item.FHIDE==='N'">
                                <template slot="label" ><span v-if="item.key=='SHPDTTM'" style="color:red;margin-right:8px">*</span>{{ $translate.getColTitle(item, $store.state.lang) }}</template>
                                <el-date-picker size="medium" :disabled="saveFlag||item.DISABLED==='Y'?true:false" type="date"  v-if="item.EDCSS==='date'" v-model="mainRow[item.FLDNO]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>
                                <el-input-number size="medium" :precision="item.DOTNUM" :disabled="saveFlag"  v-else-if="item.EDCSS==='number'" v-model="mainRow[item.FLDNO]" style="width:100%" ></el-input-number>
                                <el-checkbox size="medium" border disabled v-else-if="item.EDCSS==='checkbox'" true-label="Y"  false-label="N" v-model="mainRow[item.FLDNO]" style="width:100%"></el-checkbox>
                                <el-input size="medium" :placeholder="item.HOLDER" type="text" v-else :disabled="item.DISABLED==='Y'?true:false||saveFlag "  v-model="mainRow[item.FLDNO]"></el-input>
                            </FormItem>
                        </span>
                    </Form>
                </span>
                <div class="one-div">
                    <span class="oneRow">{{ $LANG('0992', '送货明细') }}</span>
                </div>
                <el-table  :data="dtlData"
                    border
                    class="custom-table-border"
                    size="small"
                    ref="refdtl"
                    show-summary
                    v-loading="v_loading"
                    :element-loading-text="$LANG('2030', '数据加载中')"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(100, 100, 100, 0.8)"
                    :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                    style="margin-top:-8px"
                    :summary-method="getMatSum"
                    :height="350"
                    highlight-current-row >
                    <el-table-column  v-for="(item ) in dtlCol.filter(item=>item.thide=='N')" :key="item.key"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"
                        :sortable="item.sortable=='N'&&item.key!=='RN'"
                        :min-width="item.width">
                        <template slot="header">{{item.title}}<span v-if="item.notnull=='Y'" style="color:red">*</span></template>
                        <template  slot-scope="scope" >
                            <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y" false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox>
                            <span v-else  >{{scope.row[item.key]}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="80">
                        <template slot-scope="scope">
                            <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:3px;"></i>
                            <el-link :disabled="saveFlag"  @click="dtlEdit(scope.row,scope.$index)" :underline="false"  ><span style="font-size:11px;margin-right:2px;">{{ $LANG('1639', '编辑') }}</span> </el-link>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="one-div"><span class="oneRow"> 附件明细【 上传PDF或图片文件】</span></div>
                <div style="display:flex" >
                    <Upload
                        ref="upload"
                        name="upfile"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="beforeImgFile"
                        :on-success="successImgFile"
                        :with-credentials="true"
                        :format="['jpg','jpeg','png','gif','tiff' ,'pdf']"
                        :max-size="10240"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :on-progress="handleProgress"
                        :action="uploadUrl"
                        style="display: inline-block;width:160px; ">
                        <div style="padding: 1px 0;width:160px;height:120px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:20px;"></el-image>
                            <p style="color:#515a6e;margin-top:5px;">{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
                        </div>
                    </Upload>
                    <div style="display:flex;margin-right:30px;flex-wrap:wrap"  >
                        <div v-for="(item,index) in imgData" :key="index" style="margin-left:10px">
                            <div v-if="item.FILEPATH&&item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" style="width:160px;height:120px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image :preview-src-list="[item.FILEPATH]"  fit="scale-down" v-else   style="width:160px;height:120px;margin-right:30px;" :src="item.FILEPATH"/>
                            <div style="width:160px;height:25px;border:1px solid #e8eaec;overflow-y:hidden">
                                <span style="font-weight:600;font-size:12px;color:red">{{ $LANG('0473', '文件名') }}：</span>{{item.FILENM}}
                            </div>
                            <div style="height:25px;background:#e8eaec;width:160px; display:flex;justify-content:space-between">
                                <el-link  :underline="false" @click="imgDel(item ,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                <el-link v-if="item.FILEPATH.toLowerCase().lastIndexOf('.pdf')>-1" :underline="false" style="margin-right:10px;" @click="pdfShow(item.FILEPATH)"><Icon type="ios-search" />{{ $LANG('0139', '查看') }}</el-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button @click="saveRec" :disabled="saveFlag" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  >{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <span>{{prompt}}</span>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>

        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div>
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>


        <!-- 明细资料框 -->
        <el-dialog v-dialogDrag  :visible.sync="dtlWin"  width="1200px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0921', '编辑记录') }}</span>
            </div>
            <Form :model="dtlRow" :label-width="120"  label-position="right" inline  >
                <span v-for="(item,index) in dtlCol" :key="index" >
                    <FormItem  :label="item.title"  :class=" 'item-width'" :prop="item.key"  v-if="item.fhide==='N'">
                        <el-date-picker type="date"  v-if="item.edcss==='date'" v-model="dtlRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>
                        <el-input-number controls-position="right" :precision="item.dotnum" :disabled="item.disabled==='Y'?true:false||saveFlag"  v-else-if="item.edcss==='number'" v-model="dtlRow[item.key]" style="width:100%" ></el-input-number>
                        <el-input  type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="dtlRow[item.key]"></el-input>
                    </FormItem>
                </span>
            </Form>
            <span slot="footer"  >
                <el-button type="info" @click="dtlWin=false" size="small"  icon="iconfont icon-shanchu">{{ $LANG('0132', '取消') }}</el-button>
                <el-button @click="dtlSure" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  >{{ $LANG('1638', '确定') }}</el-button>
            </span>
        </el-dialog>
        <!-- 送货明细 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="poWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1167', '下推送货明细') }}</span>
            </div>
            <div style="height:86vh;overflow-y:auto">
            <div class="one-toolbar">
                <span class="spanRow"  ></span>
                <el-checkbox @change="selEvent" true-label="Y" false-label="N" v-model="selAll" style="line-height:30px; margin-right:2px; "><span style="font-size:12px;color:white">{{ $LANG('0263', '全选') }}</span></el-checkbox>
                <span style="margin-left:6px">{{ $LANG('0298', '字段') }}</span>
                <el-select v-model="selparam4"  :placeholder="$LANG('1675', '请选择列名')"   size="small" style="width:150px; margin-left:4px">
                    <span v-for="(item,index) in stkCol" :key='index' >
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'&&item.edcss!=='checkbox'"></el-option>
                    </span>
                </el-select>
                <el-input clearable  :placeholder="input_hold" v-model="txtparam4" @keyup.enter.native="qryDtl" size="small" style="width:320px; height:30px; ">
                    <el-select v-model="oper4" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="qryDtl" ></el-button>
                </el-input>
                <el-button type="primary" @click="nextCate" size="small" icon="iconfont icon-shipeiqi" style=" margin-left:10px;height:30px;margin-top:2px;line-height:15px">{{ $LANG('1168', '下推选择记录') }}</el-button>
            </div>

            <el-table  :data="dtlData.filter(item=>item.ISNEXT=='N')"
                border
                size="small"
                class="custom-table-border"
                :row-key="getDtlKey"
                :cell-style="{padding:'2px'}"
                :height="400"
                cell-class-name="clearPadding"
                highlight-current-row >
                <el-table-column :label="$LANG('0310', '序号')" type="index" width="60"></el-table-column>
                <el-table-column v-for="(item ) in stkCol.filter(item=>item.thide=='N'&&item.key!=='RN')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"
                    :sortable="item.edcss!=='checkbox'&&item.key!=='RN'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template slot="header"><span style="color:red" v-if="item.notnull=='Y'">{{item.title}}</span></template>
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox>
                        <el-input type="number"  @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  v-else-if="item.key=='CHKQTY' "  v-model="scope.row[item.key]" size="mini" style="width:100%"></el-input>
                        <el-input v-else-if="item.key=='STKRMK'" :disabled="item.disabled=='Y'" v-model="scope.row[item.key]" size="mini" style="width:100%" clearable></el-input>
                        <div v-else  >{{scope.row[item.key]}}</div>
                    </template>
                </el-table-column>
            </el-table>
            <el-table  :data="nextData"
                border
                size="small"
                ref="refreq"
                class="custom-table-border"
                :cell-style="{padding:'2px'}"
                :row-key="getDtlKey"
                :height="maxHeight"
                highlight-current-row >
                <el-table-column :label="$LANG('0310', '序号')" type="index" width="55"></el-table-column>
                <el-table-column v-for="(item ) in stkCol.filter(item=>item.thide=='N'&&item.key!=='SEL')" :key="item.key"
                    :prop="item.key"
                    :label="item.title"
                    show-overflow-tooltip
                    :align="item.align"
                    :sortable="item.edcss!=='checkbox'&&item.key!=='RN'&&item.sortable=='N'"
                    :min-width="item.width">
                    <template slot="header"><span style="color:red" v-if="item.key=='CHKAMT'">{{item.title}}</span></template>
                    <template  slot-scope="scope" >
                        <el-checkbox v-if="item.edcss=='checkbox'" true-label="Y"   false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox>
                        <div v-else  >{{scope.row[item.key]}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    fixed="right"
                    :label="$LANG('0330', '操作')"
                    align="center"
                    width="75">
                    <template slot-scope="scope">
                        <el-button size="mini"  type="text" icon="el-icon-close" @click="nextDel(scope.row,scope.$index)">{{ $LANG('0131', '删除') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; ">
                <span style="float:right">
                    <el-button type="info" @click="poWin=false" size="small"  icon="iconfont icon-shanchu">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button @click="genQa" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-shengcheng"  >{{ $LANG('1118', '生成质检单') }}</el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div>
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中') }}...</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>
        </el-dialog>
    </div>
</template>
<script>
import DeliveryPage from '@/views/srmmgt/po_send.vue'
import EasyWin from '@/views/datamgt/easy_field.vue'
import { getTabColOrData } from '@/api/user'

// Keep the native delivery business implementation; use mat_datalib's
// page-local header queries and USER_FLDSET configuration in the workbench.
function createDeliveryOptions(component) {
    const source = component.options || component
    const components = { ...source.components }
    delete components.VeColumnConfigDialog
    const page = {
        ...source,
        components,
        mixins: [],
        data() {
            const data = source.data.call(this)
            data.setWin = false
            data.fldArr = []
            data.loadWin = false
            data.v_inputrow = {}
            data.v_sort = 'asc'
            data.columnWidthResizeOption = {
                enable: true,
                minWidth: 20,
                sizeChange: ({ column, columnWidth }) => {
                    const targetCol = this.vueCol.find(item=>item.key==column.key)
                    if (targetCol) targetCol.width = columnWidth
                }
            }
            return data
        },
        mounted() {
            if (source.mounted) {
                // Ensure refinput doesn't cause TypeError if removed from template
                if (!this.$refs) this.$refs = {}
                if (!this.$refs['refinput']) {
                    this.$refs['refinput'] = { focus() {} }
                }
                source.mounted.call(this)
            }
        },
        methods: {
            ...source.methods,
            enterDown(event) {
                if (event.keyCode==13) this.qryTabData()
            },
            inputChg(e, column) {
                this.v_inputrow[column] = e.target.value
                this.v_row[column] = e.target.value
            },
            rowShow() {
                this.v_inputrow = {}
                this.v_row = {}
                this.current = 1
                this.qryTabData()
            },
            dropSel(val) {
                if (val !== 'fldset') return
                this.fldArr =[]
                getTabColOrData(this.v_url ,'V_USER_FLDSET','idseq','401217-1','userno',this.v_username,'','',' order by sortby').then((res) => {
                    let v_setArr =res.result
                    //预处理：将 v_setArr中所有的FLDNO提取出来，转为大写，存入 Set
                    const existFldnos =new Set()
                    v_setArr.forEach(item=>existFldnos.add(item.FLDNO.toUpperCase()))
                    // 遍历 vueCol, 检查是否存在
                    this.vueCol.forEach(item =>{
                        const keyUpper = (item.key||'').toUpperCase()
                        if (!existFldnos.has(keyUpper)){
                            let v_obj ={'IDSEQ':'401217-1',LSTSEQ:'',COLWIDTH:item.width,CORPID:this.v_corpid,USERNO:this.v_username,FLDNO:item.key,FLDNM:item.title, 'VISFLAG':'Y'}
                            v_setArr.push(v_obj)
                            // 同时也添加到 Set 中，防止 vueCol 中有重复的 key 导致重复添加
                            existFldnos.add(keyUpper)
                        }
                    })
                    //构建Map,源数组 : key ---> COLWIDTH
                    const widthMap =new Map(this.vueCol.map(item=>[item.key,item.width]))
                    //遍历目标数组并更新
                    let updateColumns =v_setArr.map(col =>{
                        if (widthMap.has(col.FLDNO)){
                            return {...col ,COLWIDTH:widthMap.get(col.FLDNO)}
                        }
                        return col
                    })
                    this.fldArr =[...updateColumns]
                })
                this.setWin =true
            },
            getSetList(){
            getTabColOrData(this.v_url, 'V_USER_FLDSET','idseq','401217-1','userno',this.v_username,'','',' order by sortby').then((res) => {
                let v_data =res.result
                if (v_data && v_data.length>0) { // 有用户个性化记录
                    let v_arr=[]
                    this.columnHiddenOption['defaultHiddenColumnKeys'] =[]
                    // 1、隐藏 ，2、列宽 3、排序
                    v_data.forEach(item=>{
                        if (item['VISFLAG'] =='N') {
                            this.columnHiddenOption['defaultHiddenColumnKeys'].push(item['FLDNO'])
                        }else{
                            v_arr.push(item['FLDNO'])
                        }
                    })
                    this.$refs["tabref"].showColumnsByKeys(v_arr)
                    this.$refs["tabref"].hideColumnsByKeys(this.columnHiddenOption['defaultHiddenColumnKeys'])
                    //1.1 构建 Map : key -> {width,sortby,isfix} ,使用 Map 提高查找效率
                    const configMap =new Map() //建立索引映射
                    v_data.forEach(item =>{
                        configMap.set(item['FLDNO'],{COLWIDTH:item.COLWIDTH,SORTBY:item.SORTBY,ISFIX:item['ISFIX']})
                    })
                    //console.log(JSON.stringify(configMap))
                    //1.2 遍历 vueCol ,同步 width 宽度 与 冻结 fixed
                    this.vueCol.forEach(col =>{
                        const  targetCol= configMap.get(col['key'])
                        if (targetCol){
                            col.width =targetCol['COLWIDTH']
                            col.fixed =targetCol['ISFIX']=='Y'?"left":targetCol['ISFIX']=='R'?"right":false
                        }
                    })
                    //1.3 根据个性化的 SORTBY排序 来更新
                    this.vueCol.sort((a,b)=>{
                        const targetA =configMap.get(a['key'])
                        const targetB =configMap.get(b['key'])
                        const sortA = (targetA  && targetA.SORTBY!==undefined)?targetA.SORTBY:9999
                        const sortB = (targetB  && targetB.SORTBY!==undefined)?targetB.SORTBY:9999
                        return sortA - sortB
                    })
                }
            })
        },
            setOk(v_obj){
            v_obj.forEach((item,index)=>item['SORTBY']=index+1)
            this.loadWin =true
            this.$axios({
                method: 'post',
                url: 'xuper_auth/batDtlSave2' ,
                data: {p_json:JSON.stringify(v_obj), p_table:'USER_FLDSET',p_idseq:'401217-1', p_action:'S' },
            }).then(res=>{
                if (res.code=='200') {
                    this.getSetList()
                    this.setWin =false
                    this.loadWin =false
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                    this.loadWin =false
                }
            })
        },
        sortChange(params){
            let v_key=params.key ,v_edcss=''
            if (this.v_sort =='asc'){
                this.v_sort ='desc'
            }else if (this.v_sort =='desc'){
                this.v_sort ='asc'
            }
            this.tabArr.some(item=>{
                if (item['key']==v_key){
                    v_edcss =item['edcss']
                }
            })
            this.tabData.sort((a, b) => {
                if (v_edcss =='number' ){
                    if (this.v_sort =='asc'){ //a == null ? -1 : b == null ? 1 : 0
                        return a[v_key] == null ? -1 : b[v_key] == null ? 1 :   a[v_key] -b[v_key]
                    }else if (this.v_sort =='desc'){
                        return b[v_key] == null ? -1 : a[v_key] == null ? 1 :  b[v_key] -a[v_key]
                    }else{
                        return 0
                    }
                }else{
                    let nameA = a[v_key]?a[v_key].toUpperCase():a[v_key]
                    let nameB = b[v_key]?b[v_key].toUpperCase():b[v_key]
                    if (this.v_sort =='asc'){
                        return nameA == null ? -1 : nameB== null ? 1 :  nameA > nameB ? -1 : 1
                    }else{
                        return nameA == null ? 1 : nameB== null ? -1 : nameA > nameB ? 1 : -1
                    }
                }
            })
        },
            qryTabData() {
                let v_cond = '', v_oper = '', v_edcss = '', invalidNumber = false
                if (this.selparam && this.txtparam !== '' && this.txtparam != null) {
                    this.tabArr.some(item=>{
                        if (item['key']==this.selparam) v_edcss =item['edcss']
                    })
                    const value = String(this.txtparam).trim().replace(/'/g, "''")
                    v_oper = this.oper || (v_edcss=='number' ? '=' : 'like')
                    if (!['like','=','!=','>','<','>=','<='].includes(v_oper) || (v_edcss=='number' && !/^-?(?:\d+(?:\.\d*)?|\.\d+)$/.test(value))) {
                        this.promptWin=true
                        this.prompt=this.$LANG('', '请输入有效的数字和比较运算符')
                        return
                    }
                    if (v_edcss=='date' || v_edcss=='time') {
                        v_cond = v_cond + ' and substr('+this.selparam+',1,10)' + (v_oper=='like' ? '=' : v_oper) + "'" + value + "'"
                    } else if (v_oper=='like') {
                        v_cond = v_cond + ' and upper('+this.selparam+") like upper('%"+value+"%')"
                    } else if (v_edcss=='number') {
                        v_cond = v_cond + ' and '+this.selparam+v_oper+value
                    } else {
                        v_cond = v_cond + ' and '+this.selparam+v_oper+"'"+value+"'"
                    }
                }
                Object.keys(this.v_row).filter(item=>item.indexOf('#OPER')<0).forEach(item=>{
                    if (this.v_row[item] !== '' && this.v_row[item] != null) {
                        v_edcss = ''
                        this.tabArr.some(it=>{
                            if (it['key']==item) v_edcss =it['edcss']
                        })
                        const value = String(this.v_row[item]).trim().replace(/'/g, "''")
                        v_oper = this.v_row['#OPER'+item] || (v_edcss=='number' ? '=' : 'like')
                        if (!['like','=','!=','>','<','>=','<='].includes(v_oper) || (v_edcss=='number' && !/^-?(?:\d+(?:\.\d*)?|\.\d+)$/.test(value))) {
                            invalidNumber=true
                            return
                        }
                        if (v_edcss=='date' || v_edcss=='time') {
                            v_cond = v_cond + ' and substr('+item+',1,10)' + (v_oper=='like' ? '=' : v_oper) + "'" + value + "'"
                        } else if (v_oper=='like') {
                            v_cond = v_cond + ' and upper('+item+") like upper('%"+value+"%')"
                        } else if (v_edcss=='number') {
                            v_cond = v_cond + ' and '+item+v_oper+value
                        } else {
                            v_cond = v_cond + ' and '+item+v_oper+"'"+value+"'"
                        }
                    }
                })
                if (invalidNumber) {
                    this.promptWin=true
                    this.prompt=this.$LANG('', '请输入有效的数字和比较运算符')
                    return
                }
                this.current = 1
                return this.getOrdList(v_cond)
            },
        getTabField(){
            let vm =this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','401217','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                vm.initCol = res.result
                const fieldRows = res.result
                vm.tabArr = []
                vm.vueCol = []
                fieldRows.forEach(item => {
                    const title = vm.$translate.getColTitle(item, vm.$store.state.lang)
                    vm.tabArr.push({
                        title,
                        key: item.key,
                        align: item.align,
                        width: item.width,
                        thide: item.THIDE,
                        fhide: item.FHIDE,
                        edcss: item.EDCSS,
                        disabled: item.DISABLED,
                        dotnum: item.DOTNUM,
                        notnull: item.NOTNULL,
                        sortable: item.SORTABLE,
                        fix: item.fix || item.FIX,
                    })
                    if (item.THIDE !== 'N') return
                    vm.vueCol.push({
                        field: item.key,
                        key: item.key,
                        type: item.EDCSS === 'checkbox' ? 'check' : item.EDCSS,
                        title,
                        align: item.align,
                        width: Number(item.width),
                        fixed: item.fix === 'Y' || item.FIX === 'Y' ? 'left' : undefined,
                        sortable: false,
                        ellipsis: { showTitle: true },
                        renderHeaderCell: ({column}, h) => {
                            const label = <el-link underline={false} on-click={()=>{this.sortChange(column)}} style="font-size:12px;color:#03274b;font-weight:700">{column.title}</el-link>
                            if (item.EDCSS =='date'||item.EDCSS =='time') {
                                return (
                                    <div >
                                        <div style="margin-top:3px;display:flex;white-space: nowrap;  " >
                                            {label}
                                        </div>
                                        <div style="display:flex">
                                            <input  size="mini" pattern="yyyy-MM-dd"  value={this.v_inputrow[column.key]} type="date" on-keydown={(event)=>this.enterDown(event)} on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px"> </input>
                                        </div>
                                    </div>
                                )
                            }
                            if (item.key === 'STFG') {
                                return (
                                    <div>
                                        <div style="margin-top:3px;display:flex;white-space:nowrap">{label}</div>
                                        <select
                                            value={this.v_inputrow['STFG'] || ''}
                                            on-change={(e) => { this.$set(this.v_inputrow, 'STFG', e.target.value); this.qryTabData() }}
                                            style="width:100%;background:white;height:28px;margin-top:1px;border:1px solid #dcdfe6;border-radius:2px;font-size:12px;padding:0 4px;"
                                        >
                                            <option value="">全部</option>
                                            <option value="Y">{this.$LANG('2047', '是')}</option>
                                            <option value="N">{this.$LANG('2044', '否')}</option>
                                        </select>
                                    </div>
                                )
                            }
                            if (item.key === 'ISSTK') {
                                return (
                                    <div>
                                        <div style="margin-top:3px;display:flex;white-space:nowrap">{label}</div>
                                        <select
                                            value={this.v_inputrow['ISSTK'] || ''}
                                            on-change={(e) => { this.$set(this.v_inputrow, 'ISSTK', e.target.value); this.qryTabData() }}
                                            style="width:100%;background:white;height:28px;margin-top:1px;border:1px solid #dcdfe6;border-radius:2px;font-size:12px;padding:0 4px;"
                                        >
                                            <option value="">全部</option>
                                            <option value="Y">{this.$LANG('2047', '是')}</option>
                                            <option value="N">{this.$LANG('2044', '否')}</option>
                                        </select>
                                    </div>
                                )
                            }
                            if (item.EDCSS!=='number') {
                                return (
                                    <div >
                                        <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                            {label}
                                        </div>
                                        <div style="display:flex">
                                            <input  disabled={item.EDCSS=='image'}  value={this.v_inputrow[column.key]} on-keydown={(event)=>this.enterDown(event)}  on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px" size="mini"></input>
                                        </div>
                                    </div>
                                )
                            } else {
                                return (
                                    <div >
                                        <div style="margin-top:3px;display:flex;white-space: nowrap; " >
                                            {label}
                                        </div>
                                        <div style="display:flex">
                                            <select  style="width:60px;background:white;height:28px;margin-top:1px" value={this.v_inputrow[`#OPER`+column.key]} on-change={(e)=>{this.inputChg(e,`#OPER`+column.key)}}>
                                                <option    value="=" style="height:30px;line-height:30px">=</option>
                                                <option    value=">" style="height:30px;line-height:30px">&gt;</option>
                                                <option    value="<" style="height:30px;line-height:30px">&lt;</option>
                                                <option    value="!=" style="height:30px;line-height:30px">!=</option>
                                            </select>
                                            <input  disabled={item.EDCSS=='image'}  value={this.v_inputrow[column.key]} on-keydown={(event)=>this.enterDown(event)}  on-input={(e)=>{this.inputChg(e,column.key)}} style="padding:0px;margin-top:1px;width:100%;height:28px" size="mini"></input>
                                        </div>
                                    </div>
                                )
                            }
                        },
                        renderBodyCell: ({row}, h) => {
                            const value = row[item.key]
                            if (item.key === 'IDNO') return <el-link underline={false} on-click={() => this.repBtn(row)}><div style="color:#409eff;border-bottom:1px solid red;font-size:12px">{value}</div></el-link>
                            if (item.key === 'STFG') return value === 'Y' ? <el-tag size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> : value === 'N' ? <el-tag size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> : <span>{value}</span>
                            if (item.key === 'ISSTK') return value === 'Y' ? <el-tag size="mini" type="success" effect="dark">{this.$LANG('2047', '是')}</el-tag> : value === 'N' ? <el-tag size="mini" type="info" effect="dark">{this.$LANG('2044', '否')}</el-tag> : <span>{value}</span>
                            return <span>{value}</span>
                        },
                    })
                })
                vm.vueCol.unshift({
                    field: 'index',
                    key: 'rownum',
                    title: vm.$LANG('0310', '序号'),
                    width: 60,
                    align: 'center',
                    fixed: 'left',
                    renderHeaderCell: (params, h) => <el-link underline={false} on-click={() => this.rowShow()} style="font-size:12px;color:#404eff"><el-tooltip content={this.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link>,
                    renderBodyCell: ({rowIndex}) => rowIndex + 1,
                })
                vm.vueCol.push({
                    field: 'oper0',
                    key: 'oper',
                    title: vm.$LANG('0330', '操作'),
                    width: 215,
                    align: 'center',
                    fixed: 'right',
                    renderBodyCell: ({row, rowIndex}, h) => (
                        <div style="white-space:nowrap">
                            <i class="iconfont icon-chakan1" style="color:#409EFF;font-size:12px;margin-right:3px"></i>
                            <el-link on-click={() => this.editRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0139', '查看')}</span></el-link>
                            {row.STFG === 'N' ? <span><i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:3px"></i><el-link disabled={this.editBool} on-click={() => this.editRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('1639', '编辑')}</span></el-link><i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:3px"></i><el-link disabled={this.cfmBool} on-click={() => this.recSet(row, 'Y')} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0134', '审核')}</span></el-link><i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:3px"></i><el-link disabled={this.delBool} on-click={() => this.recSet(row, 'X')} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0131', '删除')}</span></el-link></span> : null}
                            {row.STFG === 'Y' ? <span> <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:3px"></i><el-link disabled={this.cfmBool} on-click={() => this.recSet(row, 'N')} underline={false}><span style="font-size:12px;margin-right:5px">{this.$LANG('0137', '弃审')}</span></el-link></span> : null}
                        </div>
                    ),
                })
                vm.getSetList()
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','401217','lstseq','2','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        notnull:res.result[k].NOTNULL,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','401217','lstseq','3','','',' order by sortby,itmseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.stkCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
        }
        }
    }
    delete page._Ctor
    delete page.render
    delete page.staticRenderFns
    delete page._scopeId
    return page
}

const options = createDeliveryOptions(DeliveryPage)
options.components = { ...options.components, EasyWin }
export default options
</script>
<style scoped lang="less">
    .el-aside {
        height: calc(100vh - 100px);// vh就是当前屏幕可见高度的1%   只用设置左侧 aside 高度
    }
    .top{
        padding: 10px;
        background: rgba(0, 153, 229);
        color: #fff;
        text-align: center;
        font-size:10px;
        border-radius: 2px;
    }
    .el-header  {
        background-color: #fff;
        color: #409EFF;
        text-align: center;
        line-height: 60px;
        width:100%;
    }
  .el-main {
    background-color: #fff;
    color: rgb(207, 206, 206);
    text-align: center;
    height:100%;
  }
  .suppo-dely-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-width: 1000px;
    height: 40px !important;
    min-height: 40px !important;
    padding: 4px 8px !important;
    background: #fff;
    line-height: normal;
    border-bottom: 1px solid #e2e8f0;
    box-sizing: border-box;

    .toolbar-left-space {
        flex: 1;
    }
    .toolbar-right-group {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-shrink: 0;

        /deep/ .el-button {
            height: 30px !important;
            line-height: 30px !important;
            padding: 0 12px !important;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
        }
        /deep/ .el-button [class*="icon-"] {
            font-size: 13px;
            margin-right: 4px;
        }
    }
  }
 .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
        min-width:200px;
    }
    .active {
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .wraper{
        width:1250px;
        margin:1px auto;
    }
</style>
<style lang="less">
    #po_send_main_table .ve-table-content-wrapper {
        min-height: 100%;
    }
    #po_send_main_table .table-head-cell-class {
        font-size: 12px !important;
        color: #03274b !important;
        background: #e2e6eb !important;
        font-weight: 700 !important;
        padding: 0 !important;
        padding-top: 4px !important;
        text-align: center !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    #po_send_main_table .table-body-cell-class1 {
        height: 20px !important;
        padding: 2px !important;
        color: black !important;
        font-size: 12px !important;
        border-width: 1px !important;
        border-color: #808695 !important;
    }
    #po_send_main_table .ve-table-header-th[fixed="right"],
    #po_send_main_table .ve-table-body-td[fixed="right"] {
        white-space: nowrap;
    }
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    }
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}

    .el-drawer__header{
        padding: 0px;
    }

    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>

<style scoped src="./fieldSettings.css"></style>
